import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../../../sporttia/all';
import { subtitleKeyForPathname } from './menuSubtitle';
import type { Menu } from './types';

/**
 * Subtítulo de la página actual a partir del menú al que pertenece la ruta.
 * Devuelve undefined fuera de los menús (y en las páginas públicas, que no
 * tienen menús cargados).
 */
export function useMenuSubtitle(): string | undefined {
    const cxt = useContext(AppContext);
    const location = useLocation();
    const { t } = useTranslation();

    const menus = (cxt?.menus?.sc as Menu[] | undefined) ?? [];
    const key = subtitleKeyForPathname(menus, location.pathname);

    if (!key) return undefined;

    const subtitle = t(key);

    // i18next devuelve la propia clave cuando no hay traducción
    return subtitle === key ? undefined : subtitle;
}
